module.exports = __webpack_public_path__ + "static/img/news.390776d0.jpg";